import { inject, Injectable } from '@angular/core';
import { UserStore } from '@lib/user/data-access';
import { NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DATE_FNS_FORMAT } from '@shared/utils/constants';
import { format, getDate, getMonth, getYear, isValid, parse as parseDate } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class DateParserService extends NgbDateParserFormatter {
  private readonly userStore = inject(UserStore);

  parse(value: string): NgbDateStruct | null {
    if (!value.trim()) {
      return null;
    }

    const formattedDate = parseDate(value, this.getDateFormat(), new Date());

    if (isValid(formattedDate)) {
      return new NgbDate(getYear(formattedDate), getMonth(formattedDate) + 1, getDate(formattedDate));
    }

    const date = new Date(value);

    if (isValid(date)) {
      return new NgbDate(getYear(date), getMonth(date) + 1, getDate(date));
    }

    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }

    const { day, month, year } = date;
    const preFormattedDate = new Date(Date.UTC(year, month - 1, day));
    return format(preFormattedDate, this.getDateFormat());
  }

  protected getDateFormat(): string {
    return DATE_FNS_FORMAT[this.userStore.dateFormat()!];
  }
}
